import classNames from "classnames";
import React from "react";
import Tag from "../../atoms/tag/tag";
import "./transactionItemTitle.sass";
import ProcessedBookingGroup from "../../../stores/domainStore/pages/models/processedBookingGroup";

export interface TransactionItemTitleProps {
  processedBookingGroup: ProcessedBookingGroup;
  isExpanded: boolean;
}

const TransactionItemTitle: React.FC<TransactionItemTitleProps> = ({
  processedBookingGroup,
  isExpanded
}) => {
  return (
    <div className="transaction-item-title">
      <div className="event-title-section">
        <div className={classNames({"is-expanded": isExpanded})}>
          {processedBookingGroup.eventTitle}
        </div>
        <span>$ {processedBookingGroup.eventPrice}</span>
      </div>
      <div className="event-info-section">
        <span>$ {processedBookingGroup.totalPrice}</span>
        <Tag
          text={processedBookingGroup.processedBookingsCount.toString()}
          type={processedBookingGroup.isSuccess ? "success" : "negative"}
        />
      </div>
    </div>
  );
};

export default TransactionItemTitle;
